<template>
  <div>
    <div>
      <vs-row>
        <vs-col>
          <span class="bold-text" style="font-size: 18px;">안전보건협의체 구성 및 운영</span>
        </vs-col>
      </vs-row>
      <vs-row class="my-4">
        <vs-col><h5><i class="dot"></i>협의체 구성</h5></vs-col>
      </vs-row>
      <vs-row class="mb-8">
        <vs-col>
          <p class="semi-bold-text">· 도급인 및 수급인 전원으로 협의체 구성</p>
          <p class="normal-text ml-4">* 도급인(부서장, 팀장, 관리감독자)과 수급인(업체 대표)</p>
        </vs-col>
      </vs-row>

      <vs-row class="mb-8" style="border:1px solid #cdcdcd;">
        <vs-col>
          <ul class="table table-1" style="border-bottom:none;">
            <li class="justify-start" style="background-color: #fafafa">
              <div>
                <span class="px-4 bold-text flex">※&nbsp;<p style="color:#EA5455;">구성제외대상</p>(고용노동부-도급시 산업재해 예방운영지침 참조)</span>
              </div>
            </li>
            <li class="justify-start p-4 text-left">
              <div>
                <p class="normal-text ml-4">· 30일 이내에 종료되는 일시적 작업, 연간 총 작업일수가 60일을 초과하지 않는 간헐적 작업</p>
                <p class="normal-text ml-4">· 자재·부품 납품, 우편물 배달 등</p>
                <p class="normal-text ml-4">· 온·오프라인을 통한 사무용품 구매시 납품, 설치, 하자보수 등</p>
                <p class="normal-text ml-4">· 용역제공 관련 회의 등 각종 회의 참석</p>
                <p class="normal-text ml-4">· 사업장 내 정수기 설치, 생수공급 및 이와 유사한 업무</p>
                <p class="normal-text ml-4">· 위험기계·기구 정기검사, 안전․ 보건관리대행, 안전보건․ 경영진단, 컨설팅, 행사, 교육    및 강의 등 사업장 내에서 수행하는 위탁 업무</p>
                <p class="normal-text ml-4">· 기타 위와 유사한 출입업체가 수행하는 업무</p>
              </div>
            </li>
          </ul>
        </vs-col>
      </vs-row>

      <vs-row class="my-4">
        <vs-col><h5><i class="dot"></i>합동 안전·보건점검</h5></vs-col>
      </vs-row>
      <vs-row class="mb-8">
        <vs-col>
          <p class="semi-bold-text">· 매월 1회 이상 정기 개최</p>
          <p class="semi-bold-text">· 안전보건협의체 회의록 기록 및 보존</p>
        </vs-col>
      </vs-row>


      <vs-row class="mb-8" style="border:1px solid #cdcdcd;">
        <vs-col>
          <ul class="table table-1" style="border-bottom:none;">
            <li class="justify-start" style="background-color: #fafafa">
              <div>
                <span class="px-4 bold-text">관련법령</span>
              </div>
            </li>
            <li class="justify-start p-4 text-left">
              <div>
                <p class="semi-bold-text">· 산업안전보건법 제64조(도급에 따른 산업재해 예방조치)</p>
                <p class="normal-text ml-4">① 1. 도급인과 수급인을 구성원으로 하는 안전 및 보건에 관한 협의체의 구성 및 운영</p>
                <p class="semi-bold-text">· 산업안전보건법 시행규칙 제79조(협의체의 구성 및 운영)</p>
                <p class="normal-text ml-4">①&nbsp;<span style="color: #FF8510">도급인 및 그의 수급인 전원</span>으로 구성해야 한다.</p>
                <p class="normal-text ml-4">② 협의체는 다음<span style="color: #FF8510"> 각 호의 사항을 협의</span>해야 한다.</p>
                <p class="normal-text ml-5">1. 작업의 시작 시간</p>
                <p class="normal-text ml-5">2. 작업 또는 작업장 간의 연락방법</p>
                <p class="normal-text ml-5">3. 재해발생 위험이 있는 경우 대피방법</p>
                <p class="normal-text ml-5">4. 작업장에서의 법 제36조에 따른 위험성평가의 실시에 관한 사항</p>
                <p class="normal-text ml-5">5. 사업주와 수급인 또는 수급인 상호 간의 연락 방법 및 작업공정의 조정</p>
                <p class="normal-text ml-4">③ 협의체는<span style="color: #FF8510"> 매월 1회 이상 정기적으로 회의를 개최</span>하고 그 결과를 <span style="color: #FF8510">기록·보존</span>해야 한다.</p>
                <p class="normal-text ml-4">☞ 위반에 대한 조치: 500만원 이하의 벌금</p>
              </div>
            </li>
          </ul>
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>

<script>
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'

export default {
  components: {
    FieldSelectModule,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FileUploadModule
  },
}
</script>

<style scoped>
.bold-text {
  font-weight: 700;
  font-size: 16px;
}
.semi-bold-text {
  font-weight: 500;
  font-size: 14px;
}

.normal-text {
  font-weight: 400;
}
</style>
